import { z } from "zod";

export const ReportExecutionHistoryDataDtoSchema = z.object({
    id: z.string(),
    jsonData: z.string().nullable(),
    columnsData: z.array(z.any()).nullable(),
    reportExecutionHistoryId: z.string(),
});

export type ReportExecutionHistoryDataDto = z.infer<typeof ReportExecutionHistoryDataDtoSchema>;